exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#rating-inline[data-v-5e2be0d6]{\r\n\tdisplay: inline !important;\r\n    padding: 0;\n}\n#rating-inline .b-rating-star[data-v-5e2be0d6]{\r\n\tpadding: 0 5px 0 0 !important;\n}\r\n", ""]);

// exports
